// extracted by mini-css-extract-plugin
module.exports = {"uploadWrapper":"Upload_uploadWrapper__3uE_R","mainBtn":"Upload_mainBtn__2YRrp","listWrapper":"Upload_listWrapper__1qvgw"};